export default function ProductCarriers() {
  return {
    productCategory: 'FE',
    productCarrierData: [
      {
        carrierName: "Corebridge",
        displayOrder: 1,
        logoLink: "https://nbapplicationdata.blob.core.windows.net/public/Consumer/logos/Carriers/corebridge.png",
      },
      {
        carrierName: "Gerber",
        displayOrder: 2,
        logoLink: "https://nbapplicationdata.blob.core.windows.net/public/Consumer/logos/Carriers/gerber.png",
      },
      {
        carrierName: "Mutual of omaha",
        displayOrder: 3,
        logoLink: "https://nbapplicationdata.blob.core.windows.net/public/Consumer/logos/Carriers/mutual-of-omaha.png",
      },
      {
        carrierName: "Transamerica",
        displayOrder: 4,
        logoLink: "https://nbapplicationdata.blob.core.windows.net/public/Consumer/logos/Carriers/transamerica.png",
      },
    ],
  }
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/FinalExpense/ProductCarriers.js